var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"landing",style:(("background-image: url(" + (_vm.$header.background_image.url ? _vm.$header.background_image.url : '') + ")")),attrs:{"id":"landing"}},[_vm._v(" 404 ")])}
var staticRenderFns = []

export { render, staticRenderFns }